import { useEffect, useMemo, useState } from 'react'
import {
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Table,
  Tooltip,
} from 'react-bootstrap'
import { CheckCircleFill, XCircleFill } from 'react-bootstrap-icons'
import { useOrdenation } from '../../hooks/useOrdenation'
import FuncionariosService from '../../services/database/FuncionariosService'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import { Ask } from '../Ask'
import { Center } from '../Center'
import { CustomSpinner } from '../CustomSpinner'

export function ModalFuncionarios({ isOpen, onClose, onSelectFuncionario }) {
  const [funcionarios, setFuncionarios] = useState([])
  const [isFuncionariosLoading, setIsFuncionariosLoading] = useState(true)
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('S')

  const filteredFuncionarios = useMemo(() => {
    let data = funcionarios

    if (search) {
      data = data.filter((funcionario) =>
        String(funcionario.NOMEFUNCIONARIO)
          .toLowerCase()
          .includes(search.toLowerCase()),
      )
    }

    if (status) {
      data = data.filter((funcionario) => funcionario.ATIVO === status)
    }

    return data
  }, [funcionarios, search, status])

  const { filteredItems, Th, Paginate } = useOrdenation(
    filteredFuncionarios,
    'NOMEFUNCIONARIO',
    'asc',
  )

  function handleSelectFuncionario(funcionario) {
    onSelectFuncionario(funcionario)
    onClose()
  }

  async function loadFuncionarios() {
    try {
      setIsFuncionariosLoading(true)

      const data = await FuncionariosService.getAll()

      setFuncionarios(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao carregar os funcionários')
    } finally {
      setIsFuncionariosLoading(false)
    }
  }

  useEffect(() => {
    if (isOpen) {
      loadFuncionarios()
    }
  }, [isOpen])

  if (!isOpen) {
    return null
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header closeButton>
        <Modal.Title>Funcionários</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {isFuncionariosLoading ? (
          <Center column>
            <CustomSpinner size={30} />
            <p>Carregando...</p>
          </Center>
        ) : (
          <>
            <Row>
              <Col>
                <Form.Label>Nome do funcionário</Form.Label>
                <Form.Control
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Digite aqui..."
                />
              </Col>

              <Col>
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  placeholder="Digite aqui..."
                >
                  <option value="">Todos</option>
                  <option value="S">Ativos</option>
                  <option value="N">Inativos</option>
                </Form.Select>
              </Col>
            </Row>

            <Table
              hover
              striped
              bordered
            >
              <thead>
                <tr>
                  <Th
                    label="ID"
                    value="IDFUNCIONARIO"
                  />
                  <Th
                    label="Nome"
                    value="NOMEFUNCIONARIO"
                  />
                  <Th label="Status" />
                </tr>
              </thead>

              <tbody>
                {filteredItems.map((funcionario) => (
                  <tr
                    style={{
                      cursor: 'pointer',
                    }}
                    onClick={() =>
                      Ask(`Selecionar ${funcionario.NOMEFUNCIONARIO}?`, () =>
                        handleSelectFuncionario(funcionario),
                      )
                    }
                  >
                    <td>{funcionario.IDFUNCIONARIO}</td>
                    <td>{funcionario.NOMEFUNCIONARIO}</td>
                    <td>
                      <OverlayTrigger
                        overlay={
                          <Tooltip>
                            {funcionario.ATIVO === 'S' ? 'Ativo' : 'Inativo'}
                          </Tooltip>
                        }
                      >
                        {funcionario.ATIVO === 'S' ? (
                          <CheckCircleFill
                            color="#00850A"
                            size={22}
                          />
                        ) : (
                          <XCircleFill
                            color="#850000"
                            size={22}
                          />
                        )}
                      </OverlayTrigger>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <Paginate />
          </>
        )}
      </Modal.Body>
    </Modal>
  )
}
